import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'saf-external',
    templateUrl: './external.component.html',
    styleUrls: ['./external.component.scss'],
    standalone: false
})
export class ExternalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
